export const deliveryBatchTypes = {
  digitalDelivery: 3,
  nextDay: 5,
  in2Days: 2,
  express90: 4
};
